import { cn } from 'utils/classNames';

import { LoadingSkeletonItem } from './LoadingSkeleton';

interface Props {
	className?: string;
	hasShelfInformation?: boolean;
	hasStoreStock?: boolean;
}

export default function LoadingBasketRowSkeletonItem({
	className,
	hasShelfInformation = false,
	hasStoreStock = false,
}: Props) {
	return (
		<div className={cn('@container flex gap-4', className)}>
			{/* Image */}
			<LoadingSkeletonItem className="size-20" />
			<div
				className={cn(
					'grow @basketMd:grid @basketMd:items-start @basketMd:gap-6 @basketMd:pt-2',
					hasShelfInformation
						? '@basketMd:grid-cols-3'
						: '@basketMd:grid-cols-2',
				)}
			>
				<div>
					{/* Title and subtitle */}
					<LoadingSkeletonItem
						height="2.75rem"
						width="90%"
						className="max-w-80"
					/>
					{/* Price */}
					<LoadingSkeletonItem height="3rem" width="5rem" className="mt-4" />
					{/* Stock */}
					<LoadingSkeletonItem
						height="text-xs"
						lines={hasStoreStock ? 2 : 1}
						width="9rem"
						className="mt-4"
					/>
				</div>
				{hasShelfInformation && (
					<LoadingSkeletonItem
						height="3.25rem"
						width="15rem"
						className="@max-basketMd:hidden"
					/>
				)}
				{/* Quantity and price */}
				<div className="flex justify-between gap-4 @max-basketMd:mt-4">
					<LoadingSkeletonItem height="2rem" width="7rem" />
					<LoadingSkeletonItem height="2rem" width="3rem" />
				</div>
				{hasShelfInformation && (
					<LoadingSkeletonItem
						height="3.25rem"
						width="15rem"
						className="mt-4 @basketMd:hidden"
					/>
				)}
			</div>
		</div>
	);
}
LoadingBasketRowSkeletonItem.displayName = 'LoadingBasketRowSkeletonItem';
